import React, { useEffect, useState } from 'react'
import { cn } from 'ethcss'
import translate from 'core/translate'
import styles from './deviceSettings__ipTvChannelGroups.jcss'
import { Button } from 'molecules/Button'
import { api } from '../../../core/api/ConnectionManager'
import Icon from '../../../blocks.simple/icon/icon'
import Checkbox from '../../../blocks.simple/checkbox/checkbox'

type GroupShort = {
    id: number
    title: string
}

export const IpTvChannelGroups = (p_: {
    channelGroupId: number[]
    onChange: (value: number[]) => void
    enabled: boolean
}) => {
    const [groupList, setGroupList] = useState<GroupShort[]>([])
    const [selectedGroups, setSelectedGroups] = useState<GroupShort[]>([])
    const [showModal, setShowModal] = useState<boolean>(false)

    useEffect(() => {
        api.send<object, GroupShort[]>('iptvGroupShort', {}).then((res) => {
            if (res) {
                setGroupList(res)
            }
        })
    }, [])

    const unlinkGroup = (id: number) => {
        p_.onChange(p_.channelGroupId.filter((itemId) => itemId !== id))
    }

    const onClose = () => {
        setSelectedGroups([])
        setShowModal(false)
    }

    const linkGroups = () => {
        const list: number[] = [...p_.channelGroupId, ...selectedGroups.map((group) => group.id)]

        p_.onChange(list)
        onClose()
    }

    const renderLinkedGroups = () => {
        const list: GroupShort[] = groupList.filter((group) => p_.channelGroupId.includes(group.id))

        return (
            <div className={styles.groupsBlock}>
                <div className={styles.groupsHeader}>{translate('groupNames')}</div>
                {list.map((item, index) => {
                    return (
                        <div className={styles.groupItem}>
                            <div className={styles.groupItemNumber}>{index + 1}</div>
                            <div className={styles.groupItemTitle}>{item.title}</div>
                            <div className={styles.groupItemDelete}>
                                <Icon
                                    type={'delete'}
                                    size={14}
                                    tooltip={{
                                        html: translate('unlinkGroupFromDevice'),
                                    }}
                                    onClick={() => unlinkGroup(item.id)}
                                />
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    const renderGroupsModal = () => {
        const freeGroups: GroupShort[] = groupList.filter((group) => !p_.channelGroupId.includes(group.id))

        return (
            <div className={styles.modal}>
                <div className={styles.modalInner}>
                    <div className={styles.modalTitle}>{translate('linkIpTvToGroup')}</div>
                    <div className={styles.modalDesc}>{translate('chooseIpTvGroup')}</div>
                    <table className={styles.table}>
                        <tr className={cn(styles.trSelection, styles.trHeader)}>
                            <td>
                                <Checkbox
                                    checked={selectedGroups.length !== 0 && selectedGroups.length === freeGroups.length}
                                    onClick={(checked: any) => {
                                        if (checked) {
                                            setSelectedGroups(freeGroups)

                                            return
                                        }

                                        setSelectedGroups([])
                                    }}
                                />
                            </td>
                            <td>
                                {translate('channelsGroups')} {freeGroups.length}
                            </td>
                        </tr>
                        {freeGroups.map((group: any) => {
                            return (
                                <tr className={styles.trSelection} key={group.id}>
                                    <td>
                                        <Checkbox
                                            checked={selectedGroups.some((item) => item.id === group.id)}
                                            onClick={() => {
                                                if (selectedGroups.some((item) => item.id === group.id)) {
                                                    setSelectedGroups(
                                                        selectedGroups.filter((item) => item.id !== group.id)
                                                    )

                                                    return
                                                }

                                                setSelectedGroups([...selectedGroups, group])
                                            }}
                                        />
                                    </td>
                                    <td>{group.title}</td>
                                </tr>
                            )
                        })}
                    </table>
                    <div className={styles.buttons}>
                        <Button onClick={onClose} className={styles.modalButton}>
                            {translate('close')}
                        </Button>
                        <Button
                            onClick={linkGroups}
                            mod={'fillBrand'}
                            className={styles.modalButton}
                            disabled={!selectedGroups.length}
                        >
                            {translate('apply')}
                        </Button>
                    </div>
                </div>
            </div>
        )
    }

    return p_.enabled ? (
        <div>
            <Button onClick={() => setShowModal(true)} mod={'fillBrand'}>
                {translate('addGroup')}
            </Button>
            {p_.channelGroupId.length ? (
                <>
                    <div className={styles.title}>{translate('ipTvGroupList')}</div>
                    {renderLinkedGroups()}
                </>
            ) : null}
            {showModal && renderGroupsModal()}
        </div>
    ) : null
}
